import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["learnings", "championInfo", "notepad", "saveStatus"]
  static values = { url: String, id: String }

  connect() {
    this.autosaveTimeout = null
    this.saveDelay = 1000 // 1 second delay for auto-save
  }

  disconnect() {
    if (this.autosaveTimeout) {
      clearTimeout(this.autosaveTimeout)
    }
  }

  scheduleAutosave() {
    // Clear any existing timeout
    if (this.autosaveTimeout) {
      clearTimeout(this.autosaveTimeout)
    }

    // Show "typing..." status
    this.updateSaveStatus("Typing...", "text-gray-500")

    // Schedule auto-save
    this.autosaveTimeout = setTimeout(() => {
      this.save()
    }, this.saveDelay)
  }

  async save() {
    this.updateSaveStatus("Saving...", "text-blue-500")

    const data = {
      conversation_evaluation: {
        learnings: this.hasLearningsTarget ? this.learningsTarget.value : "",
        champion_info: this.hasChampionInfoTarget ? this.championInfoTarget.value : "",
        notepad: this.hasNotepadTarget ? this.notepadTarget.value : ""
      }
    }

    try {
      const response = await fetch(this.urlValue, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": this.getCSRFToken(),
          "Accept": "application/json"
        },
        body: JSON.stringify(data)
      })

      if (response.ok) {
        const result = await response.json()
        this.updateSaveStatus("Saved", "text-green-500")
        
        // Clear the saved status after 2 seconds
        setTimeout(() => {
          this.updateSaveStatus("", "")
        }, 2000)
      } else {
        const error = await response.json()
        this.updateSaveStatus("Error saving", "text-red-500")
        console.error("Error saving evaluation:", error)
      }
    } catch (error) {
      this.updateSaveStatus("Error saving", "text-red-500")
      console.error("Network error:", error)
    }
  }

  saveNotepad() {
    // Direct save when clicking the save button
    this.save()
  }

  updateSaveStatus(text, className) {
    if (this.hasSaveStatusTarget) {
      this.saveStatusTarget.textContent = text
      this.saveStatusTarget.className = `mt-1 text-xs ${className}`
    }
  }

  getCSRFToken() {
    const meta = document.querySelector('meta[name="csrf-token"]')
    return meta ? meta.content : ""
  }
}